<template>
  <ons-page id="change-password">
    <app-bar :title="$t('change_pw.title')" :enable-home="false" />
    <v-ons-progress-bar indeterminate v-show="loading"></v-ons-progress-bar>
    <form action="" class="form">
      <ul class="no-bullet">
        <li class="account-gap border-bottom">
          <label for="pw-current">{{ $t('change_pw.cur_pw') }}</label>
        </li>
        <li class="account-row por-rm"><input class="form-input no-border transpare" type="password" id="pw-current" placeholder=""
          v-model="currentPassword" :disabled="isOffline"
        ></li>
        <li class="account-row por-rm"
          v-for="error in errors.current_password || []"
        ><div class="message-error">{{ error }}</div></li>
        <li class="account-gap">
          <label for="pw-new">{{ $t('change_pw.new_pw') }}</label>
        </li>
        <li class="account-row por-rm"><input class="form-input no-border transpare" type="password" id="pw-new" placeholder=""
          v-model="password" :disabled="isOffline"
        ></li>
        <li class="account-row por-rm"
          v-for="error in errors.password || []"
        ><div class="message-error">{{ error }}</div></li>
        <li class="account-gap">
          <label for="pw-new-conform">{{ $t('change_pw.confirm_pw') }}</label>
        </li>
        <li class="account-row por-rm bd-bottom"><input class="form-input no-border transpare" type="password" id="pw-new-conform" placeholder=""
         v-model="passwordConfirmation" :disabled="isOffline"
        ></li>
        <li class="account-row por-rm"
          v-for="error in errors.password_confirmation || []"
        ><div class="message-error">{{ error }}</div></li>
      </ul>
      <p class="container">
        <ons-button class="btn-outline button button--small" modifier="small"
          :disabled="loading || isOffline"
          @click="updatePassword"
        >{{ $t('change_pw.update') }}</ons-button>
      </p>
    </form>
    <v-ons-toast :visible="shouldShowGoOnlineToast" animation="ascend">
      {{ $t("messages.go_online_to_change_pw") }}
      <button @click="goOnline">{{ $t("ui.go_online") }}</button>
    </v-ons-toast>
  </ons-page>
</template>

<script>
import AppBar from '@/components/AppBar.vue';

export default {
  name: 'change-password',
  components: {
    'app-bar': AppBar
  },

  data() {
    return {
      currentPassword: null,
      password: null,
      passwordConfirmation: null,
      loading: false,
      errors: {},
    };
  },

  methods: {
    updatePassword() {
      this.errors = {};
      let hasError = false;
      // validate
      if (!this.currentPassword) {
        this.errors.current_password = [this.$t("change_pw.errors.cur_pw_empty")];
        hasError = true;
      }
      if (!this.password) {
        this.errors.password = [this.$t("change_pw.errors.new_pw_empty")];
        hasError = true;
      }
      if (!this.passwordConfirmation) {
        this.errors.password_confirmation = [this.$t("change_pw.errors.confirm_pw_empty")];
        hasError = true;
      }
      if (hasError) { return; }
      if (this.password !== this.passwordConfirmation) {
        this.errors.password_confirmation = [this.$t("change_pw.errors.new_pw_not_match")];
        hasError = true;
      }
      if (hasError) { return; }

      let that = this;
      this.loading = true;
      this.currentUser.updatePassword({
        currentPassword: this.currentPassword,
        password: this.password,
        passwordConfirmation: this.passwordConfirmation,
      }).then(() => {
        this.currentPassword = null;
        this.password = null;
        this.passwordConfirmation = null;
        this.$ons.notification.toast(this.$t("messages.pw_updated"), { timeout: 1500, animation: 'fall' });
      }).catch((error) => {
        if (error.response && error.response.status === 422) {
          for (var key in error.response.data.errors) {
            that.errors[key] = error.response.data.errors[key].map((error) => that.$t(`change_pw.errors.${key}_${error.split(' ').join('_')}`));
          }
          that.showCheckErrorsToast();
        } else {
          console.log(error);
          that.showSomethingWrongToast();
        }
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
